import { MakePayment } from "container/OnBoarding/MakePayment";
import { RegisterDog } from "container/OnBoarding/RegisterDog";
import { useState } from "react";

const RegisterDogForm = () => {
  const [step, setSteps] = useState(0);

  const onPressNext = () => {
    setSteps(1);
  };

  const onPressBack = () => {
    setSteps(0);
  };

  switch (step) {
    case 0:
      return <RegisterDog isCustom={true} onPressNext={onPressNext} />;
    case 1:
      return <MakePayment isCustom={true} onPressBack={onPressBack} />;
    default:
      return <></>;
  }
};
export default RegisterDogForm;
